import { handleActions } from 'redux-actions';

import { NAMES as VIDEO_FULL_SCREEN_ACTIONS } from 'widget/redux/client/actions/player/set-fullscreen-status';

const defaultState = {
  isInFullScreen: false,
};

const setFullScreenStatus = (state, { payload }) => ({
  ...state,
  isInFullScreen: payload,
});

export default handleActions({
  [VIDEO_FULL_SCREEN_ACTIONS.SET]: setFullScreenStatus,
}, defaultState);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/player/state.js